import React from 'react';
import nationaliies from '../data/nationalities.json'

export const WEIGHT_CLASS_CONFIG = {
    Men: [
        { label: 'Open', limit: null },
        { label: 'U105', limit: 105  },
        { label: 'U90',  limit: 90   },
        { label: 'U80',  limit: 80   },
        { label: 'U72',  limit: 72   },
        { label: 'U70',  limit: 70   },
    ],
    Women: [
        { label: 'Open', limit: null },
        { label: 'U82',  limit: 82   },
        { label: 'U73',  limit: 73   },
        { label: 'U64',  limit: 64   },
        { label: 'U57',  limit: 57   },
    ],
};

export const getWeightClassFilterOptions = () => [
    { label: 'All Classes', value: 'All' },
    ...Object.entries(WEIGHT_CLASS_CONFIG).flatMap(([gender, classes]) =>
        classes.map(({ label, limit }) => ({
            label: `${gender} ${label}`,
            value: limit ?? `${gender} Open`,
        }))
    ),
];

const WeightClassOptgroups = () => (
    <>
        {Object.entries(WEIGHT_CLASS_CONFIG).map(([gender, classes]) => (
            <optgroup key={gender} label={gender}>
                {classes.map(({ label }) => (
                    <option key={label} value={`${gender} ${label}`}>{label}</option>
                ))}
            </optgroup>
        ))}
    </>
);

export const GenderOptions = () => (
    <>
        <option value={'All'}>All Genders</option>
        <option value={'Male'}>Male</option>
        <option value={'Female'}>Female</option>
    </>
)

export const LiftOptions = () => (
    <>
        <option value={'total'}>Total</option>
        <option value={'log'}>Log</option>
        <option value={'deadlift'}>Deadlift</option>
    </>
)

export const WeightClassOptions = () => (
    <>
        <option value={'All'}>All Weight Classes</option>
        <WeightClassOptgroups />
    </>
)

export const SelectGenderOptions = () => (
    <>
        <option value={'Male'}>Male</option>
        <option value={'Female'}>Female</option>
    </>
)

export const NationalityOptions = () => {
    return (
        <>
            {nationaliies.map(nation =>
                <option key={nation} value={nation}>{nation}</option>
            )}
        </>
    )
}

export const NationalityFilterOptions = () => {
    return (
        <>
            <option value={'All'}>All Nationalities</option>
            {nationaliies.map(nation =>
                <option key={nation} value={nation}>{nation}</option>
            )}
        </>
    )
}

export const SelectWeightClassOptions = () => (
    <WeightClassOptgroups />
)
